import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import { setupInterceptors } from '@/infra/api'
import { useAuthStore } from '@/modules/auth'
import { type BeforeInstallPromptEvent, usePwa } from '@/modules/pwa'
import App from './App.vue'
import './assets/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)

setupInterceptors(
  () => {
    const authStore = useAuthStore()
    return authStore.token
  },
  () => {
    const authStore = useAuthStore()
    if (authStore.token) {
      authStore.logout()
      void router.push({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } })
    }
  }
)

app.mount('#app')

const { registerSW, captureInstallPrompt } = usePwa()

void registerSW()

window.addEventListener('beforeinstallprompt', (e: Event) => {
  captureInstallPrompt(e as BeforeInstallPromptEvent)
})
